const $greyNormalText = 'rgb(124, 135, 157)';
const $greyNoActiveLink = 'rgb(121, 133, 148)';
const $blueActiveLink = 'rgb(53, 138, 255)';
const $white = 'rgb(255, 255, 255)';
const $black = 'rgb(66, 65, 66)';
const $font1624MediumDark = 'rgb(24, 24, 61)';
const $font1624MediumLight = 'rgb(124, 135, 157)';
const $error = 'rgb(240, 112, 114)';
const $boxShadowCard = 'rgba(148, 158, 177, 0.2)';

const $flowGreen = 'rgba(104,198,171,1)';
const $flowOrange = 'rgba(251,160,80,1)';
const $flowRed = 'rgba(240,112,114,1)';

const $flowGradientHorizontalGreen = 'linear-gradient(135deg, rgba(118,199,107,1), rgba(59,197,114,1))';
const $flowGradientHorizontalOrange = 'linear-gradient(45deg, rgba(251,160,77, 0.8) 0%,  rgba(246,136,70,0.8) 100%)';
const $flowGradientHorizontalRed = 'linear-gradient(315deg, rgba(238,87,87,1), rgba(251,107,77,1))';

const $flowGradientVerticalGreen = 'linear-gradient(0deg, rgba(118,199,107,0.26), rgba(59,197,114,1))';
const $flowGradientVerticalOrange = 'linear-gradient(0deg, rgba(246,136,70,0.8) 0%, rgba(251,160,77, 0.8) 100%)';
const $flowGradientVerticalRed = 'linear-gradient(0deg, rgba(238,87,87,0.27), rgba(251,107,77,1))';
const $flowGradientVerticalBlueGray = 'linear-gradient(0deg, rgb(148,158,177) 0%, rgb(124,135,157) 100%)';
const $flowGradientVerticalTeal = 'linear-gradient(0deg, rgba(189,237,235,0.48), rgba(11,190,183,1))';
const $flowGradientVerticalLightGrey = 'linear-gradient(0deg, rgba(138,160,202, 0.8) 0%, rgba(188,201,226, 0.8) 100%)';
const $flowGradientVerticalLightGreyLowOpacity =
  'linear-gradient(0deg, rgba(138,160,202, 0.4) 0%, rgba(188,201,226, 0.4) 100%)';

export const paletteColours = {
  /* Flow Colors */
  $flowGreen,
  $flowOrange,
  $flowRed,

  /* Predict Colors */
  $predictGreen: 'rgba(104, 198, 171, 1)',
  $predictRed: 'rgba(240, 112, 114, 1)',
  $predictTableBorder: 'rgba(225, 228, 235, 1)',
  $predictRadioBtnDetail: 'rgba(18, 161, 154, 1)',
  $predictExcludedPrediction: 'rgba(61, 66, 75, 0.4)',
  $predictSubtitle: 'rgb(146, 157, 176)',
  $predictInvoicePrediction: 'rgba(240, 112, 114, 0.05)',
  $predictFutrliPrediction: 'rgba(59, 172, 197, 0.05)',

  /* Risk Colours */
  $riskLow: $flowGreen,
  $riskMedium: $flowOrange,
  $riskHigh: $flowRed,
  $flowGradientHorizontalGreen,
  $flowGradientHorizontalOrange,
  $flowGradientHorizontalRed,
  $flowGradientVerticalGreen,
  $flowGradientVerticalOrange,
  $flowGradientVerticalRed,
  $flowGradientVerticalBlueGray,
  $flowGradientVerticalTeal,
  $flowGradientVerticalLightGrey,
  $flowGradientVerticalLightGreyLowOpacity,

  /* Font Colours */
  $greyNormalText,
  $greyNoActiveLink,
  $blueActiveLink,
  $grey: 'rgb(130, 130, 130)',
  $darkGrey: 'rgba(40, 45, 46, 0.87)',
  $lightGrey: 'rgba(40, 45, 46, 0.38)',
  $caramelBrown: 'rgb(124, 78, 78)',
  $secondaryText: 'rgba(40, 45, 46, 0.38)',
  $font1624MediumDark,
  $font1624MediumLight,

  /* Inactive chart colours */
  $fadedBlue: '#bcc9e2',
  $fadedBlueGradient: '#7a8fb8',

  $chartGridLine: 'rgb(236, 238, 243)',

  /* Colours */
  $transparent: 'rgba(0, 0, 0, 0)',
  $white,
  $red: 'rgb(255, 0, 0)',
  $black,
  $pink: 'rgb(236, 90, 135)',
  $orange: 'rgb(255, 151, 107)',
  $orangeForIcon: 'rgb(249, 149, 77)',
  $blue: 'rgb(0, 226, 255)',
  $green: 'rgba(0, 212, 176, 1)',
  $activeGreen: 'rgba(170, 235, 120, 1)',
  $seafoamGreen: 'rgba(80, 227, 194, 1)',
  $pictonBlue: 'rgb(29, 196, 233)',
  $offWhite: 'rgb(251, 251, 251)',
  $reallyLightGrey: 'rgb(235, 236, 236)',
  $primaryAqua: 'rgb(0, 219, 197)',
  $tealGrey: 'rgb(176, 198, 203)',
  $lightTealGrey: 'rgb(227, 234, 237)',
  $veryDarkGrey: 'rgb(63, 59, 59)',
  $yellow: 'rgb(255, 187, 0)',
  $confirmationGreen: 'rgb(60, 197, 114)',
  $confirmationGreenDisabled: 'rgb(231, 245, 239)',
  $disabledOffGrey: 'rgb(212, 212, 212)',
  $error: 'rgb(240, 112, 114)',

  /* Background colors */
  $primaryBackgroundColor: 'rgb(241, 113, 113)',
  $primaryGradientStartColor: 'rgb(241, 113, 113)',
  $primaryGradientStopColor: 'rgb(239, 102, 138)',
  $secondaryButtonBackgroundColor: 'rgb(115, 126, 148)',
  $secondaryBackgroundColor: 'rgb(148, 158, 177)',
  $secondaryGradientStartColor: 'rgb(148, 158, 177)',
  $secondaryGradientStopColor: $greyNormalText,
  $paleGrayBackground: 'rgb(242, 243, 245)',
  $generalGrayBackground: 'rgba(246, 247, 250, 1)',
  $modalGrayBackground: 'rgb(245, 247, 249)',

  /* Button colours */
  $buttonColor: 'rgb(255, 255, 255)',
  $disabledColor: 'rgb(255, 255, 255)',
  $disabledBackgroundColor: 'rgba(66, 65, 66, 0.26)',

  /* Labels for form fields*/
  $labelColor: 'rgba(0, 0, 0, 0.55)',

  /* Box shadow color */
  $boxShadowColor: 'rgba(124, 135, 157, .6)',
  $boxShadowColorButton: 'rgba(61, 66, 75, 0.1)',
  $boxShadowColorRadioButton: 'rgba(61, 66, 75, 0.4)',
  $boxShadowCard,
  $boxShadowFooterBar: 'rgba(0,0,0,0.05)',
  $boxShadowModal: 'rgba(0,0,0,0.1)',

  /* Border Colours */
  $lightGreyBorder: 'rgb(216,217,218)',
  $mediumGreyBorder: 'rgb(223,227,236)',
  $cloudGreyBorder: 'rgb(239, 239, 239)',
  $freemiumBorder: 'rgb(216, 217, 218)',
  $premiumBorder: 'rgb(253, 182, 102)',
  $feintGrey: 'rgb(245, 247, 248)',
  $greyButtonBorder: 'rgb(223, 227, 236)',
  $greyModalBorder: 'rgb(237, 239, 243)',

  /* Background colors */
  $lightGrayBackground: 'rgb(250, 251, 252)',

  /* Opacity based Colours (WhiteLabelling) */
  $lighten: 'rgba(255, 255, 255, 0.2)',
  $darken: 'rgba(0, 0, 0, 0.2)',

  /* Veils used for overlays */
  $blackVeil: 'rgba(0, 0, 0, 0.7)',

  /* Gradients */
  $secondaryStopGradient: 'rgb(240, 62, 162)',
  $secondaryStartGradient: 'rgba(253, 182, 102)',

  /* Widget */
  $greyTitle: $font1624MediumDark,
  $greyProductName: $greyNormalText,

  /* Divider */
  $lightDivider: 'rgb(216, 217, 218)',

  /* Shadow */
  $subtleBoxShadow: 'rgba(148, 158, 177, 0.8)',

  /* Icons */
  $greyIcon: 'rgba(49, 55, 62, 1)',
  $greyDarkIcon: $black,
  $greyActiveIcon: $greyNormalText,
  $greyNoActiveIcon: 'rgba(176,198,203,0.54)',

  /* Wizard Stepper */
  $activeGreyDot: $greyNoActiveLink,
  $greyDot: 'rgb(226, 229, 231)',

  // modal colours
  $modalDialogBorderColor: 'rgba(223, 227, 236, 1)',
  $modalAltColumnBackgroundColor: 'rgba(246, 247, 250, 1)',
  $modalButtonBoxShadowColor: 'rgba(26, 52, 51, 0.05)',

  // Project colors
  $colorFlowDefault: 'rgba(251, 160, 78, 1)',
  $colorFlowActive: 'rgba(246, 136, 70, 1)',
  $colorPredictDefault: 'rgba(104, 198, 171, 1)',
  $colorPredictDisabled: 'rgba(104, 198, 171, 0.4)',
  $colorPredictActive: 'rgba(59, 172, 197, 1)',
  $colorPredictHover: 'rgba(93, 193, 165, 1)',
  $colorGreyDark: 'rgb(83, 98, 125)',

  // Text field
  $disabledGrey: 'rgb(241, 243, 247)',
  $boxShadowTextField: $boxShadowCard,

  /** Fonts colours (Typography) **/
  $fontWhite: $white,
  $fontGreyLight: $font1624MediumLight,
  $fontGreyDark: $font1624MediumDark,
  $fontRed: $error,

  /** auth screen blue background **/
  $blueGradientStartColor: 'rgba(44, 54, 78, 1)',
  $blueGradientStopColor: 'rgba(24, 30, 45, 1)',

  /* Graphs */
  $graphLightGrey: 'rgb(219, 227, 244)',

  /* Greys */
  $chartGrey1: 'rgb(175, 181, 194)',
  $chartGrey2: 'rgb(181, 187, 200)',
  $chartGrey3: 'rgb(187, 193, 205)',
  $chartGrey4: 'rgb(192, 198, 210)',
  $chartGrey5: 'rgb(198, 204, 215)',
  $chartGrey6: 'rgb(204, 210, 221)',
  $chartGrey7: 'rgb(210, 216, 226)',
  $chartGrey8: 'rgb(216, 221, 231)',
  $chartGrey9: 'rgb(222, 227, 236)',
  $chartGrey10: 'rgb(228, 233, 242)',
  $chartGrey11: 'rgb(234, 238, 247)',
  $chartGrey12: 'rgb(240, 244, 252)',

  /* Pulse */
  $chartPulse1: 'rgb(142, 27, 58)',
  $chartPulse2: 'rgb(157, 33, 66)',
  $chartPulse3: 'rgb(165, 38, 71)',
  $chartPulse4: 'rgb(180, 45, 80)',
  $chartPulse5: 'rgb(194, 56, 93)',
  $chartPulse6: 'rgb(211, 73, 110)',
  $chartPulse7: 'rgb(230, 90, 121)',
  $chartPulse8: 'rgb(240, 104, 122)',
  $chartPulse9: 'rgb(248, 125, 126)',
  $chartPulse10: 'rgb(255, 149, 150)',
  $chartPulse11: 'rgb(255, 189, 190)',
  $chartPulse12: 'rgb(255, 229, 230)',
  /* Gradients */
  $chartPulseGradientStart: 'rgb(222, 89, 124)',
  $chartPulseGradientStop: 'rgb(240, 112, 114)',

  /* Flow */
  $chartFlow1: 'rgb(221, 90, 38)',
  $chartFlow2: 'rgb(226, 97, 46)',
  $chartFlow3: 'rgb(227, 107, 45)',
  $chartFlow4: 'rgb(232, 113, 51)',
  $chartFlow5: 'rgb(238, 126, 59)',
  $chartFlow6: 'rgb(246, 136, 70)',
  $chartFlow7: 'rgb(249, 149, 77)',
  $chartFlow8: 'rgb(251, 160, 78)',
  $chartFlow9: 'rgb(255, 171, 95)',
  $chartFlow10: 'rgb(255, 187, 125)',
  $chartFlow11: 'rgb(255, 217, 183)',
  $chartFlow12: 'rgb(255, 240, 226)',
  /* Gradients */
  $chartFlowGradientStart: 'rgb(246, 136, 70)',
  $chartFlowGradientStop: 'rgb(251, 160, 77)',

  /* Predict */
  $chartPredict1: 'rgb(17, 91, 128)',
  $chartPredict2: 'rgb(21, 100, 139)',
  $chartPredict3: 'rgb(24, 116, 149)',
  $chartPredict4: 'rgb(26, 128, 160)',
  $chartPredict5: 'rgb(39, 148, 172)',
  $chartPredict6: 'rgb(54, 172, 185)',
  $chartPredict7: 'rgb(67, 191, 189)',
  $chartPredict8: 'rgb(104, 198, 181)',
  $chartPredict9: 'rgb(119, 217, 194)',
  $chartPredict10: 'rgb(144, 230, 205)',
  $chartPredict11: 'rgb(182, 247, 228)',
  $chartPredict12: 'rgb(214, 253, 242)',

  $chartPredictPast: 'rgb(204,204,204)',
  /* Gradients */
  $chartPredictGradientStart: 'rgb(104, 198, 171)',
  $chartPredictGradientStop: 'rgb(59, 172, 197)',
  /* Layers */
  $chartPredictTodayLayer: 'rgba(124, 135, 157)',

  /* Xero SSO button */
  $xeroSSOButtonColor: 'rgb(64, 71, 86)',
  $xeroSSOButtonHoverBackground: 'rgb(241, 242, 243)',

  /* Datasource status colours*/
  $syncSuccess: 'rgb(104, 198, 171)',
  $syncError: $error,
  $disconnected: 'rgb(187, 187, 187)',

  /* New chart colors */
  $chartGrey: 'rgb(224,227,235)',
  $chartLightGrey: 'rgb(246,247,250)',
  $chartLimeGreen: 'rgb(95,145,125)',
  $chartSoftRed: 'rgb(236,104,114)',
  $chartLightCyan: 'rgb(204,251,242)',
  $chartLightRed: 'rgb(251,226,232)'
};
